import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoColegioPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoColegioPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoColegio(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'TipoColegio', name: 'TipoColegio', title: 'Tipo Colegio' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            // unidadAcademicas: [],
            tipoColegio: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoColegio() {
            this.tipoColegio = {};
            this.$refs['frm-tipoColegio'].show();
        },
        showTipoColegio(id) {
            console.log("show");
            
            this.isLoading=true;
            this.ss.showTipoColegio(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoColegio = response.data;
                    this.$refs['view-tipoColegio'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoColegio() {
            this.$refs['frm-tipoColegio'].show();
            this.$refs['view-tipoColegio'].hide();
        },
        cancelTipoColegio() {
            if (this.tipoColegio.id) {
                this.$refs['view-tipoColegio'].show();
            }
            this.$refs['frm-tipoColegio'].hide();
        },
        saveTipoColegio() {
            this.ss.storeTipoColegio(this.tipoColegio).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoColegio'].hide();
                    this.$refs['datatable-tipoColegio'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        destroyTipoColegio() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoColegio(this.tipoColegio)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoColegio'].hide();
                                this.$refs['datatable-tipoColegio'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoColegio').on('click', (evt) => {
                console.log("evento click");
                const data = window.$(evt.target)[0].id;
                this.showTipoColegio(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
